import {
    ref
} from 'vue';
export const lunContent = ref(null)
export const tanContent = ref(null)